/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import styles from "./TaxUtilityReport.styles";
import Loader from "../../../components/Loader/Loader";
import PageSyncCal from "../../../components/Layout/PageSyncCal";
import Heading from "../../../components/Layout/Heading";
import { OuterContainerStyles } from "../../../components/Layout/Typography";
import UploadFile from "./Components/UploadFile";
// import ExportButton from "../TotalCollection/Components/ExportButton/ExportButton";
import ExportButton from "./Components/ExportButton/ExportButton";
import Button from "../../../components/Layout/Button";
import { SERVICES } from "../../../components/Layout/Services";
import { postFormData } from "../../../components/Layout/ApiHandler/apihandler";
import { ToastAlertContext } from "../../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../../contants";
import DateRangePicker from "../Components/DateRangePicker/DateRangePicker";

const LOADER_DELAY = 1000;
const PAGE = "page";

const initialFormValue = {
  startDate: new Date(),
  endDate: new Date(),
};

function TaxUtilityReport() {
  const [isLoading, setIsLoading] = useState(false);
  const [filename, setFilename] = useState("");
  const [zipFile, setZipFile] = useState(null);
  const fileInputRef = useRef(null);
  const [initialAdvanceFormValue, setInitialAdvanceFormValue] =
    useState(initialFormValue);

  const toast = React.useContext(ToastAlertContext);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setFilename(file?.name);
    if (file) {
      const reader = new FileReader();
      reader.onload = (fileLoadEvent) => {
        const arrayBuffer = fileLoadEvent.target.result;
        setZipFile(arrayBuffer);
      };

      reader.readAsArrayBuffer(file);
    }
  };
  const handleButtonChoose = () => {
    fileInputRef.current.click();
  };

  // const handleSubmit = async () => {
  //   try {
  //     if (zipFile) {
  //       setIsLoading(true);
  //       const formData = new FormData();
  //       formData.append(
  //         "file",
  //         new Blob([zipFile], { type: "text/html" }),
  //         filename,
  //       );
  //       const url = `${SERVICES.UPLOAD_INCOME_TAX_UTILITY_FILE}`;
  //       const response = await postFormData(url, formData);
  //       if (response.code === 200) {
  //         const { data } = response;
  //         toast.show("File Upload Successfully", AlertStatus.SUCCESS);
  //         setIsLoading(false);
  //       } else {
  //         setIsLoading(false);
  //       }
  //     }
  //   } catch (error) {
  //     toast.show("Error uploading file. Please try again.", AlertStatus.ERROR);
  //     setIsLoading(false);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };
  const handleSubmit = async () => {
    try {
      if (zipFile) {
        setIsLoading(true);

        // Step 1: Get S3 URL
        const xAuthToken = localStorage.getItem("X-Auth-Token");
        const encodedFilename = encodeURIComponent(filename);
        const getUrlResponse = await fetch(
          `${SERVICES.GET_S3_URL}?fileKey=${encodedFilename}`,
          {
            method: "GET",
            headers: {
              "X-Auth-Token": xAuthToken,
            },
          },
        );

        if (!getUrlResponse.ok) {
          throw new Error("Failed to get S3 URL");
        }

        const { data } = await getUrlResponse.json();

        // Step 2: Upload ZIP file directly to S3 using PUT
        const uploadResult = await fetch(data, {
          method: "PUT",
          body: new Blob([zipFile], { type: "application/zip" }),
          headers: {
            "Content-Type": "application/zip",
            // "X-Auth-Token": xAuthToken,
          },
        });

        if (!uploadResult.ok) {
          throw new Error("Failed to upload file to S3");
        }

        // Step 3: Hit the process pdf api
        const submitResponse = await fetch(
          `${SERVICES.PROCESS_PDFS_FILE}?fileKey=${encodedFilename}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Auth-Token": xAuthToken,
            },
          },
        );

        if (!submitResponse.ok) {
          throw new Error("Failed to submit file key");
        }

        toast.show("File uploaded successfully!", AlertStatus.SUCCESS);
      }
    } catch (error) {
      toast.show(
        error.message || "Error during file upload process",
        AlertStatus.ERROR,
      );
    } finally {
      setIsLoading(false);
    }
  };
  const handleButtonClear = () => {
    setFilename("");
    setZipFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };
  return (
    <div style={{ width: "100%", overflowX: "auto", overflowY: "hidden" }}>
      <PageSyncCal />
      <Heading title="Tax Utility Report" />
      <OuterContainerStyles marginTop="24px" marginBottom="24px">
        <div style={styles.container}>
          <Box style={styles.tableTitle}>Export CSV To Income Tax</Box>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "30px",
            }}
          >
            {/* <div /> */}
            <DateRangePicker
              label="Date"
              name="date"
              startDateVal={initialAdvanceFormValue.startDate}
              endDateVal={initialAdvanceFormValue.endDate}
              onChange={(startDate, endDate) => {
                setInitialAdvanceFormValue({
                  ...initialAdvanceFormValue,
                  startDate,
                  endDate,
                });
              }}
            />
            <div>
              <ExportButton initialAdvanceFormValue={initialAdvanceFormValue} />
            </div>
          </div>
          <Box style={styles.tableTitle}>Upload Zip File</Box>
          <UploadFile
            handleFileUpload={handleFileUpload}
            handleButtonChoose={handleButtonChoose}
            fileInputRef={fileInputRef}
            filename={filename}
          />
          {/* <Box style={styles.noteText}>
            Note<span style={styles.redAsterisk}>*</span>: Size of the upload
            file should not exceed 5MB
          </Box> */}
          <nav
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "20px",
            }}
          >
            <div />
            <Box sx={{ display: "flex", gap: "10px" }}>
              <Button onClick={handleSubmit} disabled={!zipFile}>
                Save
              </Button>
              <Button cancel onClick={handleButtonClear}>
                Cancel
              </Button>
            </Box>
          </nav>
          {isLoading && <Loader />}
        </div>
      </OuterContainerStyles>
    </div>
  );
}
export default TaxUtilityReport;
